import { AxiosInstance } from 'axios';
import { ActivityApplyInfo, RegisterInfo } from '../constants';

export const getPlayerServices = ({ GateWayInstance }: { GateWayInstance: AxiosInstance }) => ({
  registerActivity({ aid, registerInfo }: { aid: string; registerInfo?: Partial<RegisterInfo> }) {
    return GateWayInstance.post<ActivityApplyInfo>(`/players/${aid}/register`, { ...registerInfo });
  },
});
